






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { BoardActionsKeys, BoardActionsPayload, Label } from '@/store/types/board';

@Component({})
export default class DeleteLabel extends Vue {
  @Action(BoardActionsKeys.DELETE_LABEL) deleteLabel!: (payload: BoardActionsPayload['DELETE_LABEL']) => Promise<void>;
  @Prop(Object) label!: Label;

  dialog = false;

  async removeLabel() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await this.deleteLabel(this.label.id);
    this.dialog = false;
  }
}
